import type { IAccount } from "@apis/accounts/types"

export const serializePlanRewardsData = (accountData: IAccount) => {
  const { plan_name, plan_rewards_description } = accountData

  return {
    plan_name: plan_name,
    plan_rewards_description: plan_rewards_description,
  }
}
